import { render, staticRenderFns } from "./SkuList.vue?vue&type=template&id=053c950e"
import script from "./SkuList.vue?vue&type=script&lang=js"
export * from "./SkuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053c950e')) {
      api.createRecord('053c950e', component.options)
    } else {
      api.reload('053c950e', component.options)
    }
    module.hot.accept("./SkuList.vue?vue&type=template&id=053c950e", function () {
      api.rerender('053c950e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/GoodsInfoTab/SkuList.vue"
export default component.exports